// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ohzc","input":"styles_input__2C_QB"};